'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Template } from './Template';
import { useViewModel } from './useViewModel';
export const StarSelector = ({ ariaLabelledBy, ariaDescribedBy, className, onStarClick, rating, starSize, disabled, }) => {
    const viewModel = useViewModel({ onStarClick, rating });
    return (_jsx(Template, { ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, className: className, starSize: starSize, disabled: disabled, ...viewModel }));
};
//# sourceMappingURL=index.js.map